import React, { useState } from "react";
import StandingsTable from "components/resultados/StandingsTable";
import PublicMatchCard from "./PublicMatchCard";
import PublicTeamModal from "./PublicTeamModal";
import PublicListasFe from "./PublicListasFe";
import { ordenarFechas, numerosDeFecha, etiquetaFecha } from "components/torneos/fechas";

// Partidos de una fecha ordenados por hora (los que no tienen hora, al final).
const ordenarPartidos = (matches = []) =>
  [...matches].sort((a, b) => {
    if (!a.hora) return 1;
    if (!b.hora) return -1;
    return a.hora.localeCompare(b.hora);
  });

// Pantalla final pública, con dos vistas que se eligen con los botones de arriba:
// - "Resultados" (la que abre por defecto): tabla de posiciones (sobre card), los
//   partidos de la fecha (sobre card) y los resultados de las fechas anteriores de
//   la misma zona, de la más reciente a la más vieja (sobre card). Tocando un
//   equipo de la tabla se abre el modal con todos sus partidos.
// - "Listas de fe": los equipos que juegan la fecha y, al tocar uno, los jugadores
//   con presencia confirmada.
// Todo SOLO LECTURA.
//
// Los resultados se actualizan solos mientras la pantalla está abierta; el botón
// del header es para el que no quiere esperar al próximo chequeo.
export default function PublicResultsScreen({
  zone,
  date,
  teams,
  headerTitle,
  onBack,
  onRefresh,
  refrescando,
}) {
  const [equipoModal, setEquipoModal] = useState(null); // teamId o null
  const [vista, setVista] = useState("resultados"); // "resultados" | "listas"
  const partidosOrdenados = ordenarPartidos(date.matches);

  // Fechas previas de la zona (las anteriores a la que se está viendo), de la
  // más reciente a la más vieja.
  const numeros = numerosDeFecha(zone.matchDates);
  const ordenadas = ordenarFechas(zone.matchDates);
  const indice = ordenadas.findIndex((f) => f.id === date.id);
  const fechasAnteriores = indice > 0 ? ordenadas.slice(0, indice).reverse() : [];

  return (
    <div className="tpub-screen">
      <div className="tpub-head">
        {onBack && (
          <button type="button" className="tpub-back" onClick={onBack} aria-label="Volver">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>
        )}
        <div className="tpub-head-text">
          <div className="tpub-title">{headerTitle}</div>
          <div className="tpub-subtitle">{zone.name}</div>
        </div>
        {onRefresh && (
          <button
            type="button"
            className={"tpub-refresh" + (refrescando ? " tpub-refrescando" : "")}
            onClick={onRefresh}
            disabled={refrescando}
            aria-label="Actualizar resultados"
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <polyline points="23 4 23 10 17 10" />
              <polyline points="1 20 1 14 7 14" />
              <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
            </svg>
          </button>
        )}
      </div>

      <div className="tpub-tabs">
        <button
          type="button"
          className={"tpub-tab" + (vista === "resultados" ? " tpub-tab--activa" : "")}
          onClick={() => setVista("resultados")}
        >
          Resultados
        </button>
        <button
          type="button"
          className={"tpub-tab" + (vista === "listas" ? " tpub-tab--activa" : "")}
          onClick={() => setVista("listas")}
        >
          Listas de fe
        </button>
      </div>

      {vista === "listas" ? (
        <PublicListasFe date={date} teams={teams} />
      ) : (
        <>
        <div className="tpub-card">
          <div className="tpub-card-title">Tabla de posiciones</div>
          <StandingsTable
            zone={zone}
            upToFechaId={date.id}
            teams={teams}
            onTeamClick={setEquipoModal}
          />
        </div>

        <div className="tpub-card">
          <div className="tpub-card-title">Partidos</div>
          {partidosOrdenados.length === 0 ? (
            <p className="tpub-empty tpub-empty--card">No hay partidos en esta fecha.</p>
          ) : (
            partidosOrdenados.map((m) => <PublicMatchCard key={m.id} match={m} teams={teams} />)
          )}
        </div>

        {fechasAnteriores.length > 0 && (
          <div className="tpub-card">
            <div className="tpub-card-title">Fechas anteriores</div>
            {fechasAnteriores.map((f) => {
              const partidos = ordenarPartidos(f.matches);
              return (
                <div className="tpub-fecha-previa" key={f.id}>
                  <div className="tpub-fecha-previa-title">{etiquetaFecha(f, numeros[f.id])}</div>
                  {partidos.length === 0 ? (
                    <p className="tpub-empty tpub-empty--card">No hay partidos en esta fecha.</p>
                  ) : (
                    partidos.map((m) => <PublicMatchCard key={m.id} match={m} teams={teams} />)
                  )}
                </div>
              );
            })}
          </div>
        )}
        </>
      )}

      <PublicTeamModal
        zone={zone}
        teams={teams}
        teamId={equipoModal}
        upToFechaId={date.id}
        onClose={() => setEquipoModal(null)}
      />
    </div>
  );
}
